import { createSlice } from '@reduxjs/toolkit';
import { fetchInstallationsForDropdown, InstallationOption } from '../../dispatchers/WellTestDispatcher';

// Extended state interface to support loading and error
const initialState = {
  data: [] as InstallationOption[],
  loading: false,
  error: undefined,
};

const WellTestInstallationsSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setWellTestInstallationsInitialState: (state) => {
      state.data = [];
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder;
    builder
      .addCase(fetchInstallationsForDropdown.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInstallationsForDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchInstallationsForDropdown.rejected, (state, action) => {
        state.loading = false;
        console.log('action.error.message::', action.error.message);
      });
  },
});

export const { setWellTestInstallationsInitialState } = WellTestInstallationsSlice.actions;

export default WellTestInstallationsSlice.reducer;
